import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ExpertHandymanSolutionsForYourHome from "./sections/ExpertHandymanSolutionsForYourHome";
import TheViralityEngine from "./sections/TheViralityEngine";
import ExpertNote from "./sections/ExpertNote";
import VoicesOfTheDiscerning from "./sections/VoicesOfTheDiscerning";
import TheDirectorsPath from "./sections/TheDirectorsPath";
import ReadyToTransformYourFuture from "./sections/ReadyToTransformYourFuture";
import RodapeInformativo from "@/reusable_sections/Footer";
import FeaturesGrid from "./sections/FeaturesGrid";
import FullWidthVisualCloser from "./sections/FullWidthVisualCloser";
export default function HomePage() {
  return <div>
      <Header />
      <ExpertHandymanSolutionsForYourHome />
      <TheViralityEngine />
      <ExpertNote />
      <FeaturesGrid />
      <VoicesOfTheDiscerning />
      <TheDirectorsPath />
      <ReadyToTransformYourFuture />
      <FullWidthVisualCloser />
      <RodapeInformativo />
    </div>;
}